module.exports = __webpack_public_path__ + "img/Pdf.bfead945.jpg";